import { useTranslations } from 'next-intl'

import ArtworksSlider from '~/components/atoms/ArtworksSlider/ArtworksSlider'
import Loader from '~/components/atoms/Loader/Loader'
import VerticalPadder from '~/components/atoms/VerticalPadder/VerticalPadder'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'
import { useRelatedArtworks } from '~/services/query'
import { toURL } from '~/utils/urlResolver'

import styles from './RelatedArtworks.module.css'

export interface RelatedArtworksProps {
  artistId?: string
  artworkId?: string
  formatId?: string
  year?: number
  excludeCollection?: string
  overrideData?: any
  fallbackData?: any
  limit?: number
  showAllLink?: boolean
  testID?: string
  relatedArtist?: {
    name: string
    slug: string
  }
  title?: string
  searchInsightsEvents?: {
    artwork: TSearchAnalystEventProps
    artist?: TSearchAnalystEventProps
  }
  noArtistLink?: boolean
}

export default function RelatedArtworks({
  artistId,
  artworkId,
  formatId,
  year,
  excludeCollection,
  overrideData,
  fallbackData,
  limit,
  showAllLink,
  testID,
  relatedArtist,
  title,
  searchInsightsEvents,
  noArtistLink,
}: RelatedArtworksProps) {
  const t = useTranslations('articlePage')
  let artworks: any = overrideData
  let loading = false
  let algoliaQueryId = undefined

  if (!overrideData && artistId) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, isLoading, error } = useRelatedArtworks(
      artistId,
      formatId,
      artworkId,
      excludeCollection,
      year,
      fallbackData
    )

    loading = isLoading
    if (data && !error) {
      const relatedArtWork = data?.find(d => d.type === 'relatedArtWork')
      if (relatedArtWork && relatedArtWork?.data?.length > 0) {
        artworks = relatedArtWork.data
        algoliaQueryId = relatedArtWork.insightsQueryID
      }
      const relatedFormat = data?.find(d => d.type === 'relatedFormat')
      if (relatedFormat && relatedFormat?.data?.length > 0) {
        artworks = relatedFormat.data
        algoliaQueryId = relatedFormat.insightsQueryID
      }
      const relatedPriority = data?.find(d => d.type === 'relatedPriority')
      if (relatedPriority && relatedPriority?.data?.length > 0) {
        artworks = relatedPriority.data
        algoliaQueryId = relatedPriority.insightsQueryID
      }
    }
  }

  const mainTitle = title ? title : t('relatedWork')

  return (
    <div className={styles.base} data-testid={testID}>
      {loading ? (
        <Loader />
      ) : (
        <VerticalPadder>
          {artworks && (
            <ArtworksSlider
              artworks={artworks}
              title={mainTitle}
              insightsQueryID={algoliaQueryId}
              searchInsightsEvents={searchInsightsEvents}
              noArtistLink={noArtistLink}
              viewAlleventName={`${mainTitle} view all button clicked`}
              viewAllLink={
                relatedArtist &&
                toURL({
                  _type: 'artist',
                  slug: relatedArtist.slug,
                })
              }
            />
          )}
          {/* {theData && showAllLink && relatedArtist && !isMobile && (
            <div className={styles.allArtworksBtn}>
              <Button
                variant={ButtonVariants.secondaryDark}
                iconLeft={true}
                link={toURL({
                  _type: 'artist',
                  slug: relatedArtist.slug,
                })}
              >
                More {relatedArtist.name} Artworks
              </Button>
            </div>
          )} */}
        </VerticalPadder>
      )}
    </div>
  )
}
